import { component } from "picoapp";
import choozy from "choozy";
import { on, toggle, qsa, qs, remove, add } from "@selfaware/martha";

import { gsap, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

export default component((node, ctx) => {
  qs("main").append(node);

  const achors = qsa("[data-anchor]");

  let sectionContainer = document.createElement("div");
  add(sectionContainer, "faq-container");

  qs("main").append(sectionContainer);

  qsa("section").forEach((section) => {
    sectionContainer.append(section);
  });

  achors.forEach((anchor) => {
    let btn = document.createElement("button");
    btn.innerHTML = anchor.dataset.title;
    add(btn, "btn");
    qs(".faq-anchor-container").append(btn);

    on(btn, "click", () => {
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: `[data-anchor="${anchor.dataset.anchor}"]`,
          offsetY: 50,
        },
        ease: "expo.out",
      });
    });
  });
});
